import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { ApplicationRequest } from '../../types/applications'

const { APPLICATIONS_API_URL } = CONSTANT

const createNewApplication = async (
	newApplication: ApplicationRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(
		`${APPLICATIONS_API_URL}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				action: 'CREATE'
			},
			body: JSON.stringify(newApplication)
		}
	)

	return response.json()
}

export default createNewApplication
